window.CartTimer = window.CartTimer || {};

const CART_TIMER_KEY = 'cartTimerDeadline';
let CART_TIMER_DURATION_MIN = 15;
let countdownInterval = null;

window.CartTimer.init = function () {
  const timerEl = document.querySelector('[data-cart-timer]');
  if (!timerEl) return;

  const parent = timerEl.closest('.cart-timer');
  const timeAttr = parent?.getAttribute('data-time');
  const currentDuration = parseInt(timeAttr, 10);

  if (!isNaN(currentDuration)) {
    CART_TIMER_DURATION_MIN = currentDuration;
  }

  const savedDeadline = parseInt(localStorage.getItem(CART_TIMER_KEY), 10);
  const now = Date.now();

  if (!savedDeadline) {
    window.CartTimer.set();
    return;
  }

  const remainingMs = savedDeadline - now;
  const remainingMinutes = Math.ceil(remainingMs / (60 * 1000));

  if (CART_TIMER_DURATION_MIN < remainingMinutes) {
    window.CartTimer.set();
  } else if (remainingMs <= 0) {
    window.CartTimer.clearCart();
    localStorage.removeItem(CART_TIMER_KEY);
  } else {
    window.CartTimer.start();
  }
};

window.CartTimer.set = function () {
  const deadline = Date.now() + CART_TIMER_DURATION_MIN * 60 * 1000;
  localStorage.setItem(CART_TIMER_KEY, deadline);
  window.CartTimer.start();
};

window.CartTimer.start = function () {
  clearInterval(countdownInterval);
  countdownInterval = setInterval(() => {
    const remaining = window.CartTimer.getRemaining();
    const timerEl = document.querySelector('[data-cart-timer]');

    if (timerEl) {
      timerEl.textContent = window.CartTimer.format(remaining);
      timerEl.closest('.cart-timer')?.classList.remove('loading');
    }

    if (remaining <= 0) {
      clearInterval(countdownInterval);
      window.CartTimer.clearCart();
      localStorage.removeItem(CART_TIMER_KEY);
    }
  }, 500);
};

window.CartTimer.getRemaining = function () {
  const deadline = parseInt(localStorage.getItem(CART_TIMER_KEY), 10);
  const now = Date.now();
  return Math.max(0, deadline - now);
};

window.CartTimer.format = function (ms) {
  const totalSeconds = Math.floor(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
};

window.CartTimer.clearCart = function () {
  fetch('/cart/clear.js', { method: 'POST' }).then(() => location.reload());
};

window.addEventListener('DOMContentLoaded', () => {
  window.CartTimer.init();
});